import { MaintenanceRequest } from '@/types/maintenance';

const statuses: MaintenanceRequest['status'][] = ['Open', 'In Progress', 'On Hold', 'Resolved'];
const priorities: MaintenanceRequest['priority'][] = ['Low', 'Medium', 'High', 'Urgent'];

const blockNames = ['Bloco A', 'Bloco B', 'Bloco C', 'Bloco D'];
const unitNames = ['Unidade 101', 'Unidade 102', 'Unidade 201', 'Unidade 202', 'Unidade 301', 'Unidade 302'];
const employeeNames = ['João Silva', 'Maria Santos', 'Carlos Oliveira', 'Ana Costa'];
const vendorNames = ['Técnicos ABC', 'Manutenção Pro', 'Serviços Rápidos', 'Especialistas'];

export const maintenanceRequests: MaintenanceRequest[] = Array.from({ length: 50 }, (_, idx) => {
  const id = `maintenance-${idx + 1}`;
  const createdAt = new Date();
  createdAt.setDate(createdAt.getDate() - Math.floor(Math.random() * 365));
  const updatedAt = new Date(createdAt);
  updatedAt.setDate(updatedAt.getDate() + Math.floor(Math.random() * 30));
  const statusIndex = idx % statuses.length;
  const priorityIndex = idx % priorities.length;
  const blockIndex = idx % blockNames.length;
  const unitIndex = idx % unitNames.length;
  const employeeIndex = idx % employeeNames.length;
  const vendorIndex = idx % vendorNames.length;

  const status = statuses[statusIndex];
  const priority = priorities[priorityIndex];
  const block = blockNames[blockIndex];
  const unit = unitNames[unitIndex];
  const employee = employeeNames[employeeIndex];
  const vendor = vendorNames[vendorIndex];

  return {
    id,
    title: `Solicitação de Manutenção ${idx + 1}`,
    description: `Descrição da solicitação de manutenção ${idx + 1}`,
    status,
    priority,
    reportedBy: {
      id: `resident-${Math.floor(Math.random() * 20) + 1}`,
      name: `Residente ${Math.floor(Math.random() * 20) + 1}`,
      email: `residente${Math.floor(Math.random() * 20) + 1}@example.com`,
      phone: `+55 11 9${Math.floor(Math.random() * 9000) + 1000}-${Math.floor(Math.random() * 9000) + 1000}`
    },
    block: {
      id: `block-${blockIndex + 1}`,
      name: block
    },
    apartmentUnit: {
      id: `unit-${unitIndex + 1}`,
      name: unit
    },
    assignedTo: Math.random() > 0.5 ? {
      id: `employee-${employeeIndex + 1}`,
      name: employee,
      email: `employee${employeeIndex + 1}@example.com`,
      phone: `+55 11 9${Math.floor(Math.random() * 9000) + 1000}-${Math.floor(Math.random() * 9000) + 1000}`
    } : undefined,
    vendor: Math.random() > 0.7 ? {
      id: `vendor-${vendorIndex + 1}`,
      name: vendor,
      email: `vendor${vendorIndex + 1}@example.com`,
      phone: `+55 11 9${Math.floor(Math.random() * 9000) + 1000}-${Math.floor(Math.random() * 9000) + 1000}`
    } : undefined,
    estimatedCost: Math.floor(Math.random() * 5000) + 100,
    actualCost: status === 'Resolved' ? Math.floor(Math.random() * 5000) + 100 : undefined,
    estimatedCompletionDate: new Date(createdAt.getTime() + Math.random() * 30 * 24 * 60 * 60 * 1000),
    completedAt: status === 'Resolved' ? new Date(createdAt.getTime() + Math.random() * 30 * 24 * 60 * 60 * 1000) : undefined,
    resolutionNotes: status === 'Resolved' ? `Problema resolvido em ${updatedAt.toLocaleDateString()}. Todos os sistemas funcionando adequadamente.` : undefined,
    attachments: [],
    tags: ['manutenção', 'urgente', 'sistema'],
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    },
    createdAt,
    updatedAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: { 
          id: 'user-1', 
          name: 'Admin User',
          displayName: 'Admin User'
        }
      },
      {
        timestamp: updatedAt,
        type: 'updated',
        performedBy: { 
          id: 'user-1', 
          name: 'Admin User',
          displayName: 'Admin User'
        },
        details: 'Solicitação atualizada'
      }
    ]
  };
}); 